import { useState } from 'react';
import LuxPageHero from '../components/lux/LuxPageHero';
import LuxReveal from '../components/lux/LuxReveal';
import LuxCta from '../components/lux/LuxCta';
import SocialLinks from '../components/SocialLinks';
import { Icon } from '../components/ui/Icons';
import { courseNames } from '../data/courses';

const contactItems = [
  { icon: 'mapPin', title: 'Visit Our Lab', info: 'Ground Floor, E-25 Sector-3, Noida\nOpp. Shiv Mandir E Block,\nNear Sector-16 Metro – 201301', link: null },
  { icon: 'phone', title: 'Admission Helpline', info: '+91 88518 68521\n+91 82383 75399', link: 'tel:+918851868521' },
  { icon: 'mail', title: 'Email Support', info: 'hr@bharattraining.com\ninfo@bharattraining.com', link: 'mailto:hr@bharattraining.com' },
  { icon: 'whatsapp', title: 'WhatsApp Us', info: 'Chat with our counsellors for instant help.', link: 'https://wa.me/918851868521' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', course: courseNames[0], msg: '' });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const send = () => {
    if (!form.name || !form.phone) return alert('Please fill your Name and Contact Number.');
    const text =
      `*Bharat Training — Enquiry*%0AName: ${form.name}%0APhone: ${form.phone}%0ACourse: ${form.course}%0AMessage: ${form.msg || 'Interested in this course.'}`;
    window.open(`https://wa.me/918851868521?text=${text}`, '_blank');
  };

  return (
    <>
      <LuxPageHero label="Get In Touch" title="Contact" highlight="Us" description="Our counsellors will help you pick the right course and start your journey." />

      <section className="lux-page-section">
        <div className="container-wide lux-grid-2 contact-grid">
          <div>
            {contactItems.map((c, i) => (
              <LuxReveal key={c.title} delay={i * 0.08}>
                <div className="lux-card" style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', gap: 14 }}>
                    <div className="icon-wrap" style={{ width: 44, height: 44 }}><Icon name={c.icon} size={20} /></div>
                    <div>
                      <h4 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: 8 }}>{c.title}</h4>
                      {c.link ? (
                        <a href={c.link} target="_blank" rel="noreferrer" style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.7, whiteSpace: 'pre-line' }}>{c.info}</a>
                      ) : (
                        <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.7, whiteSpace: 'pre-line' }}>{c.info}</p>
                      )}
                    </div>
                  </div>
                </div>
              </LuxReveal>
            ))}
            <LuxReveal delay={0.2}>
              <div className="lux-card">
                <h4 style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: 14 }}>
                  <Icon name="clock" size={16} /> Office Hours
                </h4>
                {[['Mon – Sat', '9:00 AM – 7:00 PM'], ['Sunday', '10:00 AM – 4:00 PM']].map(([day, time]) => (
                  <div key={day} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 14 }}>
                    <span style={{ color: 'var(--text-muted)' }}>{day}</span>
                    <span style={{ fontWeight: 600 }}>{time}</span>
                  </div>
                ))}
              </div>
            </LuxReveal>
            <LuxReveal delay={0.25}>
              <div style={{ marginTop: 24 }}>
                <p className="lux-statement__eyebrow" style={{ marginBottom: 12 }}>Follow us</p>
                <SocialLinks size="lg" />
              </div>
            </LuxReveal>
          </div>

          <LuxReveal delay={0.1} x={24}>
            <div className="lux-form-panel">
              <h2>Free <span className="accent">Counselling</span></h2>
              <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 28 }}>Fill the form — we&apos;ll reply on WhatsApp.</p>
              <div className="form-field">
                <label className="form-label">Full Name *</label>
                <input className="form-input" type="text" placeholder="Your name" value={form.name} onChange={e => set('name', e.target.value)} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }} className="form-row-2">
                <div className="form-field">
                  <label className="form-label">Phone *</label>
                  <input className="form-input" type="tel" placeholder="+91..." value={form.phone} onChange={e => set('phone', e.target.value)} />
                </div>
                <div className="form-field">
                  <label className="form-label">Course</label>
                  <select className="form-input" value={form.course} onChange={e => set('course', e.target.value)}>
                    {courseNames.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-field">
                <label className="form-label">Message</label>
                <textarea className="form-input" rows={4} placeholder="Your query..." value={form.msg} onChange={e => set('msg', e.target.value)} />
              </div>
              <button type="button" className="btn-lux btn-lux--fill" style={{ width: '100%', justifyContent: 'center', color: '#030712', border: 'none', cursor: 'pointer' }} onClick={send}>
                Send via WhatsApp
              </button>
            </div>
          </LuxReveal>
        </div>

        <LuxReveal delay={0.15}>
          <div style={{ marginTop: 64 }}>
            <h3 className="video-gallery__title" style={{ fontSize: '1.75rem', marginBottom: 20 }}>Locate <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>us</em></h3>
            <div style={{ border: '1px solid var(--border)', height: 360, overflow: 'hidden' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.2458622114256!2d77.3115456!3d28.5923984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce4f620f38f4d%3A0xc6c42171171804f5!2sSector%203%2C%20Noida!5e0!3m2!1sen!2sin"
                width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" title="Bharat Training Location"
              />
            </div>
          </div>
        </LuxReveal>
      </section>
    </>
  );
}
